import React, { useState, useEffect } from "react";
import "./About.css";

const About = () => {
  const [showMore, setShowMore] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const handleResize = () => {
    setIsMobile(window.innerWidth < 768); // Assuming mobile view is below 768px
  };

  useEffect(() => {
    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  return (
    <div className="container-fluid d-flex align-items-center min-vh-100 bg-dark text-light">
      <div className="row w-100">
        <h1 className="mb-5 text-center mt-3">About Me</h1>
        <div className="col-md-6 d-flex justify-content-center">
          <img
            src="/images/zaheer_profile_squre.jpg"
            alt="zaheer_profile"
            className="zaheer_img"
          />
        </div>
        <div className="col-md-6 d-flex justify-content-center  mt-3">
          <div>
            <p>
              Hello! I’m Zaheer Baig, a skilled{" "}
              <span style={{ color: "#5CA904" }}>MERN</span> stack developer
              with <span style={{ color: "#007bff" }}>two years</span> of
              hands-on experience in the software development industry. My
              journey in tech began with a strong focus on{" "}
              <span style={{ color: "#ff5f57" }}>frontend development</span>.
            </p>
            {(showMore || !isMobile) && (
              <>
                <p>
                  I’ve honed my skills in creating responsive, user-centric
                  interfaces that elevate the user experience. My expertise
                  extends to <span style={{ color: "#febc2e" }}>UI design</span>{" "}
                  principles, enabling me to build intuitive, visually appealing
                  applications that are both functional and aesthetically
                  pleasing.
                </p>
                <p>
                  Beyond frontend, I am proficient in{" "}
                  <span style={{ color: "#007bff" }}>backend technologies</span>
                  , particularly with{" "}
                  <span style={{ color: "#5CA904" }}>Node.js</span> and{" "}
                  <span style={{ color: "yellow" }}>Express.js</span>. This dual
                  knowledge allows me to deliver robust{" "}
                  <span style={{ color: "red" }}>full-stack</span> solutions
                  that meet project requirements end-to-end. Working with modern
                  development frameworks and libraries has given me the agility
                  to adapt to project demands and innovate within dynamic team
                  environments.
                </p>
                <p>
                  As I continue my journey, my goal is to build impactful,
                  memorable projects that bring value to users and clients
                  alike. I am passionate about staying up-to-date with emerging
                  technologies and refining my skills with every project I
                  undertake.
                </p>
              </>
            )}
            {isMobile && (
              <button
                onClick={toggleShowMore}
                className="btn btn-link text-light"
              >
                {showMore ? "Show Less" : "Show More"}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
